import rModelsBase from './rModelsBase';

export interface IUstBilgiNode {
  ToplamDeger: number;
  Alan: number;
  Sayi: number;
}

interface IUstBilgi {
  KullanimAmacli: IUstBilgiNode;
  YatirimAmacli: IUstBilgiNode;
  Toplam: IUstBilgiNode;
}

const setIUstBilgiNode = (o1?: IUstBilgiNode, o2?: IUstBilgiNode): IUstBilgiNode => {
  return {
    ToplamDeger: o1?.ToplamDeger || o2?.ToplamDeger || 0,
    Alan: o1?.Alan || o2?.Alan || 0,
    Sayi: o1?.Sayi || o2?.Sayi || 0,
  };
};

export default class rUstBilgi extends rModelsBase implements IUstBilgi {
  constructor(options1?: IUstBilgi, options2?: rUstBilgi) {
    super();
    this.KullanimAmacli = setIUstBilgiNode(options1?.KullanimAmacli, options2?.KullanimAmacli);
    this.YatirimAmacli = setIUstBilgiNode(options1?.YatirimAmacli, options2?.YatirimAmacli);
    this.Toplam = setIUstBilgiNode(options1?.Toplam, options2?.Toplam);
  }

  public KullanimAmacli: IUstBilgiNode;
  public YatirimAmacli: IUstBilgiNode;
  public Toplam: IUstBilgiNode;
}
